/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskConnectProjectRoute } from '@jira/router-routes__connect-routes/src/servicedeskConnectProjectRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { getProjectConnectRouteDefaultResources } from './common/index.tsx';
import { connectProjectsWithoutHorizontalNavPageEntrypoint } from './ui/spa/connect/projects/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskConnectProjectRouteEntry: Route = createEntry(
	servicedeskConnectProjectRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getProjectConnectRouteDefaultResources(),
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
		],

		ufoName: 'jira-connect',
		entryPoint: () => connectProjectsWithoutHorizontalNavPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
